const o = "{{currentTime}} de {{duration}}", n = "Resultado de búsqueda {{current}} de {{total}}", t = "No se han encontrado resultados", c = "Se ha encontrado {{count}} resultado", e = "Se han encontrado {{count}} resultados", s = 'Reproduciendo desde $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) y $t(SECONDS, { "count": {{seconds}} }).', a = 'Reproduciendo desde $t(MINUTES, { "count": {{minutes}} }) y $t(SECONDS, { "count": {{seconds}} }).', r = 'Reproduciendo desde $t(SECONDS, { "count": {{seconds}} }).', A = "Error al guardar los cambios en la transcripción.", i = "Línea de transcripción en {{time}}. El contenido es: {{text}}.", E = 'Contenedor de líneas de transcripción. Hay $t(TRANSCRIPT_LINES, { "count": {{count}} }) dentro de este contenedor. Para navegar dentro del contenedor, utiliza la flecha hacia abajo.', d = "Guardando los cambios...", T = "Cambios guardados en la transcripción.", _ = "Ya está disponible el botón Actualizar subtítulos.", u = "Acción", S = "Añadir notas en el punto {{time}}", R = "Añadir pregunta a las {{time}}", N = "Anotaciones", l = "Automático", I = "Automático ({{quality}})", O = "Volver", C = "Subtítulos", P = "Idioma de los subtítulos", U = "Administrar subtítulos", L = "Eliminar {{language}}", p = "Tamaño de fuente", D = "Idioma de los subtítulos: {{language}}", m = "{{language}} (automático)", M = "Borrar búsqueda", G = "Cerrar", b = "Comentarios", Y = "Continuar", h = "Disminuir velocidad de reproducción", g = "Disminuir volumen un {{percent}}%", v = "Flecha hacia abajo", H = "Cerrar editor de transcripciones", V = "Actualizar subtítulos", B = "Error", F = "Guardando...", K = "¡Guardado!", W = "Editar transcripción", $ = "¡El texto no puede estar vacío!", q = "Pantalla completa", Q = "{{count}} hora", f = "{{count}} horas", y = "Aumentar velocidad de reproducción", z = "Aumentar volumen un {{percent}}%", J = "Invertir colores", j = "Saltar a determinado porcentaje (1-10 %, 2-20 %, etc.)", x = "Saltar al inicio", Z = "Acciones para {{title}}", X = "Métodos abreviados de teclado", k = "Idioma", w = "Flecha hacia la izquierda", oo = "Menú principal", no = "{{count}} minuto", to = "{{count}} minutos", co = "Silenciar", eo = "Silenciado", so = "Siguiente idioma de subtítulos", ao = "Siguiente resultado de búsqueda", ro = "Desactivado", Ao = "En la parte superior", io = "Abrir nota en el punto {{time}}", Eo = "Abrir prueba completada en el punto {{time}}", To = "Abrir prueba en el punto {{time}}", _o = "Pausar", uo = "Reproducir", So = "Velocidad de reproducción", Ro = "Velocidad de reproducción: x{{speed}}", No = "Idioma de subtítulos anterior", lo = "Resultado de búsqueda anterior", Io = "Calidad", Oo = "Menú de calidad", Co = "Repetir", Po = "Restablecer velocidad de reproducción", Uo = "Flecha hacia la derecha", Lo = "Buscar en la transcripción", po = "{{count}} segundo", Do = "{{count}} segundos", mo = "Buscar hacia atrás: {{seconds}} segundos", Mo = "Buscar hacia delante: {{seconds}} segundos", Go = "Configuraciones", bo = "Atajo", Yo = "Herramientas y detalles de archivos multimedia", ho = "Barra espaciadora", go = "Menú de velocidad de reproducción", vo = "Iniciar desplazamiento automático", Ho = "Activar/desactivar subtítulos", Vo = "Activar/desactivar silenciado", Bo = "Reproducción/pausa", Fo = "es {{count}} línea de transcripción", Ko = "son {{count}} líneas de transcripción", Wo = "Cargando transcripción...", $o = "No se ha podido cargar la transcripción.", qo = "Opciones de transcripción", Qo = "Reintentar", fo = "Transcripción no disponible", yo = "Flecha hacia arriba", zo = "Configuraciones de vídeo", Jo = "Volumen", jo = "Volumen: {{volume}}%", xo = {
  A11Y_DURATION: o,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: c,
  A11Y_SEARCH_RESULTS_FOUND_other: e,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: a,
  A11Y_TIMESTAMP_JUMP_SECONDS: r,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: i,
  A11Y_TRANSCRIPT_LINES: E,
  A11Y_TRANSCRIPT_SAVING: d,
  A11Y_TRANSCRIPT_SUCCESS: T,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: _,
  ACTION: u,
  ADD_ANNOTATION_AT: S,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: N,
  AUTO: l,
  AUTO_QUALITY: I,
  BACK: O,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: p,
  CAPTION_LANGUAGE: D,
  CAPTION_LANGUAGE_AUTOMATIC: m,
  CLEAR_SEARCH: M,
  CLOSE: G,
  COMMENTS: b,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: h,
  DECREASE_VOLUME: g,
  DOWN_ARROW: v,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: V,
  EDIT_ERROR: B,
  EDIT_SAVING: F,
  EDIT_SUCCESS: K,
  EDIT_TRANSCRIPT: W,
  EDIT_VALIDATION_ERROR: $,
  FULLSCREEN: q,
  HOURS: Q,
  HOURS_other: f,
  INCREASE_PLAYBACK_SPEED: y,
  INCREASE_VOLUME: z,
  INVERT_COLORS: J,
  JUMP_TO_PERCENTAGE: j,
  JUMP_TO_START: x,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: oo,
  MINUTES: no,
  MINUTES_other: to,
  MUTE: co,
  MUTED: eo,
  NEXT_CAPTION_LANGUAGE: so,
  NEXT_HIT: ao,
  OFF: ro,
  ON_TOP: Ao,
  OPEN_ANNOTATION_AT: io,
  OPEN_COMPLETED_QUIZ_AT: Eo,
  OPEN_QUIZ_AT: To,
  PAUSE: _o,
  PLAY: uo,
  PLAYBACK_SPEED: So,
  PLAYBACK_SPEED_MESSAGE: Ro,
  PREVIOUS_CAPTION_LANGUAGE: No,
  PREVIOUS_HIT: lo,
  QUALITY: Io,
  QUALITY_MENU: Oo,
  REPLAY: Co,
  RESET_PLAYBACK_SPEED: Po,
  RIGHT_ARROW: Uo,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lo,
  SECONDS: po,
  SECONDS_other: Do,
  SEEK_BACKWARD: mo,
  SEEK_FORWARD: Mo,
  SETTINGS: Go,
  SHORTCUT: bo,
  SIDEBAR: Yo,
  SPACE: ho,
  SPEED_MENU: go,
  START_AUTOSCROLL: vo,
  TOGGLE_CAPTIONS: Ho,
  TOGGLE_MUTED: Vo,
  TOGGLE_PLAY_PAUSE: Bo,
  TRANSCRIPT_LINES: Fo,
  TRANSCRIPT_LINES_other: Ko,
  TRANSCRIPT_LOADING: Wo,
  TRANSCRIPT_LOAD_ERROR: $o,
  TRANSCRIPT_OPTIONS: qo,
  TRANSCRIPT_RETRY: Qo,
  TRANSCRIPT_UNAVAILABLE: fo,
  UP_ARROW: yo,
  VIDEO_SETTINGS: zo,
  VOLUME: Jo,
  VOLUME_VALUE: jo
};
export {
  o as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  c as A11Y_SEARCH_RESULTS_FOUND,
  e as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  a as A11Y_TIMESTAMP_JUMP_MINUTES,
  r as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  i as A11Y_TRANSCRIPT_LINE,
  E as A11Y_TRANSCRIPT_LINES,
  d as A11Y_TRANSCRIPT_SAVING,
  T as A11Y_TRANSCRIPT_SUCCESS,
  _ as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  u as ACTION,
  S as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  N as ANNOTATIONS,
  l as AUTO,
  I as AUTO_QUALITY,
  O as BACK,
  C as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  p as CAPTION_FONT_SIZE,
  D as CAPTION_LANGUAGE,
  m as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  G as CLOSE,
  b as COMMENTS,
  Y as CONTINUE,
  h as DECREASE_PLAYBACK_SPEED,
  g as DECREASE_VOLUME,
  v as DOWN_ARROW,
  H as EDIT_CLOSE,
  V as EDIT_CONFIRM,
  B as EDIT_ERROR,
  F as EDIT_SAVING,
  K as EDIT_SUCCESS,
  W as EDIT_TRANSCRIPT,
  $ as EDIT_VALIDATION_ERROR,
  q as FULLSCREEN,
  Q as HOURS,
  f as HOURS_other,
  y as INCREASE_PLAYBACK_SPEED,
  z as INCREASE_VOLUME,
  J as INVERT_COLORS,
  j as JUMP_TO_PERCENTAGE,
  x as JUMP_TO_START,
  Z as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  oo as MAIN_MENU,
  no as MINUTES,
  to as MINUTES_other,
  co as MUTE,
  eo as MUTED,
  so as NEXT_CAPTION_LANGUAGE,
  ao as NEXT_HIT,
  ro as OFF,
  Ao as ON_TOP,
  io as OPEN_ANNOTATION_AT,
  Eo as OPEN_COMPLETED_QUIZ_AT,
  To as OPEN_QUIZ_AT,
  _o as PAUSE,
  uo as PLAY,
  So as PLAYBACK_SPEED,
  Ro as PLAYBACK_SPEED_MESSAGE,
  No as PREVIOUS_CAPTION_LANGUAGE,
  lo as PREVIOUS_HIT,
  Io as QUALITY,
  Oo as QUALITY_MENU,
  Co as REPLAY,
  Po as RESET_PLAYBACK_SPEED,
  Uo as RIGHT_ARROW,
  Lo as SEARCH_TRANSCRIPT_PLACEHOLDER,
  po as SECONDS,
  Do as SECONDS_other,
  mo as SEEK_BACKWARD,
  Mo as SEEK_FORWARD,
  Go as SETTINGS,
  bo as SHORTCUT,
  Yo as SIDEBAR,
  ho as SPACE,
  go as SPEED_MENU,
  vo as START_AUTOSCROLL,
  Ho as TOGGLE_CAPTIONS,
  Vo as TOGGLE_MUTED,
  Bo as TOGGLE_PLAY_PAUSE,
  Fo as TRANSCRIPT_LINES,
  Ko as TRANSCRIPT_LINES_other,
  Wo as TRANSCRIPT_LOADING,
  $o as TRANSCRIPT_LOAD_ERROR,
  qo as TRANSCRIPT_OPTIONS,
  Qo as TRANSCRIPT_RETRY,
  fo as TRANSCRIPT_UNAVAILABLE,
  yo as UP_ARROW,
  zo as VIDEO_SETTINGS,
  Jo as VOLUME,
  jo as VOLUME_VALUE,
  xo as default
};
